import invariant from 'tiny-invariant'

interface ObjectItem {
  entityId: string
  userId: string
}

export const createObjectPath = (item: ObjectItem) => {
  const { userId, entityId } = item
  invariant(userId, 'User ID must be defined')
  invariant(entityId, 'Entity ID must be defined')
  return `users/${item.userId}/storage/${item.entityId}`
}
